import React from 'react';

import {Row} from 'presentation/components';
import {useGetHealthCardQuery} from 'presentation/pages/private/health-card/queries/useGetHealthCardQuery';
import {translations} from 'presentation/translations-new';
import {UserInfoSkeleton} from '../UploadRefundFiles/UserInfoSkeleton';

const {company: companyLabel} = translations['pt-br'].privateFlow.refund.holderDataPage.userInfo;

export function EnterpriseField() {
	const {data: healthCardInfo, isError, isLoading} = useGetHealthCardQuery();

	if (isLoading) {
		return <UserInfoSkeleton />;
	}

	if (isError) {
		return null;
	}

	return <Row.Simple title={companyLabel} value={healthCardInfo?.nomeEmpresa} />;
}
